import { z } from 'zod';

export const identifiantsSchema = z.object({
  email: z.string().trim().min(1),
  motDePasse: z.string().min(1),
});
export type Identifiants = z.infer<typeof identifiantsSchema>;

export const utilisateurSchema = z.object({
  id: z.string().min(1),
  email: z.string().email(),
});
export type Utilisateur = z.infer<typeof utilisateurSchema>;

export const sessionSchema = z.object({
  jeton: z.string().min(1),
  /** Expiry instant, ISO 8601 with a UTC offset. */
  expireLe: z.string().datetime({ offset: true }),
  utilisateur: utilisateurSchema,
});
export type Session = z.infer<typeof sessionSchema>;
